import { createContext } from 'react';

export const WalletContext = createContext({
  address: '',
  addressDisplay: '',
  networkName: '',
  chainId: null,
  ethBalance: '0',
  isConnected: false,
  isConnecting: false,
  isSwitchingAccount: false,
  accountSwitchState: {
    status: 'disconnected',
    message: '',
    previousAddress: '',
    activeAddress: '',
    errorCode: null,
    updatedAt: 0,
  },
  provider: null,
  signer: null,
  connectWallet: async () => {},
  switchAccount: async () => {},
  disconnectWallet: () => {},
  switchToExpectedNetwork: async () => {},
  refreshWalletState: async () => {},
  clearAccountSwitchState: () => {},
});

